import { render } from "./Header.vue?vue&type=template&id=76c27252"
const script = {}
script.render = render

export default script